import useInitDarkMode from '@hook/useInitDarkMode'

const DarkModeInitializer = () => {
    useInitDarkMode()
    return null
}
export default DarkModeInitializer
